
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/estate-agents/results",
      function () {
        return require("private-next-pages/estate-agents/results.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/estate-agents/results"])
      });
    }
  